"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyMacros = applyMacros;
exports.getMacroKey = getMacroKey;

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

var _get2 = _interopRequireDefault(require("lodash/get"));

var _startCase2 = _interopRequireDefault(require("lodash/startCase"));

var _keys2 = _interopRequireDefault(require("lodash/keys"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));

var _num = _interopRequireDefault(require("@nerdwallet/nw-client-lib/num"));

var replaceValue = function replaceValue(keysIndex, formattedValue, value, hasMultipleValues) {
  if (hasMultipleValues && value === "{{".concat(keysIndex, "}}")) {
    return formattedValue;
  }

  if ((0, _isString2.default)(value)) {
    return value && value.replace("{{".concat(keysIndex, "}}"), formattedValue);
  }

  if ((0, _isArray2.default)(value)) {
    return value.map(function (item) {
      return replaceValue(keysIndex, formattedValue, item, hasMultipleValues);
    });
  }

  return value;
};

function getMacroKey(config, propName) {
  if (config[propName]) {
    var propValue = config[propName]; // First replace all of the string minus the macro.

    var macroStr = propValue.replace(/[^{{\d}}]/g, '');

    if (macroStr !== '') {
      // Replace the {{ and the }} and find the key index.
      var keyIndex = macroStr.replace('{{', '').replace('}}', '');
      var keyConfig = config.keys[keyIndex]; // Do we have a corresponding key config ?

      if (keyConfig) {
        // Return the key string.
        return keyConfig.key;
      }
    }
  } // If we didn't find a macro, return the unaltered key.


  return config.key;
}

function applyMacros(rawConfig, data) {
  var isObject = !(0, _isArray2.default)(rawConfig);
  var rawConfigAsArray = rawConfig; // Is the config an object ?

  if (isObject) {
    // Convert it to an array
    rawConfigAsArray = [rawConfig];
  }

  var result = rawConfigAsArray.map(function (configParam) {
    // Deep clone the config.
    var config = (0, _cloneDeep2.default)(configParam);
    (0, _forEach2.default)(config.keys || [], function (valueCfg, keysIndex) {
      var formattedValue = null; // Do we have a getValue in the config ?

      if (typeof valueCfg.getValue === 'function') {
        // Invoke the function ...
        formattedValue = valueCfg.getValue(data);
      } else {
        formattedValue = (0, _get2.default)(data, valueCfg.key, '');
      }

      if (formattedValue !== '' && valueCfg.type !== undefined) {
        var formatFn = (0, _startCase2.default)(valueCfg.type);
        formattedValue = _num.default["format".concat(formatFn)](formattedValue, valueCfg.formatterStr);
      }

      (0, _keys2.default)(config).forEach(function (key) {
        config[key] = replaceValue(keysIndex, formattedValue, config[key], !!config.multiple);
      });
    });
    return config;
  }); // If an object was passed in, return the object or else return the resulting array.

  return isObject ? result[0] : result;
}